<template>
  <main id="home" class="site-main">
    <div
      v-if="$store.state.portalSettings.myshopify_domain == 'wizzle-world.myshopify.com' || $store.state.portalSettings.myshopify_domain == 'visceral-apps-staging.myshopify.com'">
      <div class="grid-container grid-container--small">
        <h4><strong>Contact Info</strong></h4>
        <p><strong>Customer Support</strong>
          contact@wizzleworld.net<br/><strong>wizz1er</strong>
          wizz1er@wizzleworld.net<br/><strong>Discord</strong> wizz1er#1337<br/><strong></strong>
        </p>
        <h4><strong>Links</strong></h4>
        <ul>
          <li><a href="https://wizzleworld.net/apps/vendor-portal/"
                 target="_blank" title="Vendor Portal"
                 rel="noopener noreferrer"> Vendor Portal</a> (you are here)
          </li>
          <li><a href="https://vendorconsignment.visceralapps.com/"
                 target="_blank" title="vendorconsignment"
                 rel="noopener noreferrer">OLD Vendor Portal</a> (has stream
            alerts)
          </li>
          <li><a href="https://wizzle.world/xyz" target="_blank"
                 title="Price List" rel="noopener noreferrer"> Price List</a>
          </li>
          <li><a href="https://wizzle.world/discord" title="Discord">Discord</a>
          </li>
          <li><a href="https://wizzle.world/twitter" title="Twitter">Twitter</a>
          </li>
          <li><a href="https://wizzle.world/tiktok" title="TikTok">TikTok</a>
          </li>
          <li><a href="https://wizzle.world/facebook"
                 title="Facebook">Facebook</a></li>
          <li><a href="https://wizzle.world/instagram" title="Instagram">Instagram</a>
          </li>
          <li><a href="https://wizzle.world/twitch" title="Twitch">Twitch</a>
          </li>
          <li><a href="https://wizzle.world/youtube" title="YouTube">Youtube</a>
          </li>
        </ul>
        <h4><strong>Shop</strong></h4>
        <div id="collection-component-1623345465798"></div>
      </div>
    </div>
  </main>
</template>

<script>
import client from '@/mixins/client'
import authenticationMixin from '@/mixins/authentication'
import utils from '@/mixins/utils'

export default {
  name: 'vendorPortalLogin',
  mixins: [client, authenticationMixin, utils],
  components: {},
  created () {
    (function () {
      var scriptURL = 'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js'
      if (window.ShopifyBuy) {
        if (window.ShopifyBuy.UI) {
          ShopifyBuyInit()
        } else {
          loadScript()
        }
      } else {
        loadScript()
      }

      function loadScript () {
        var script = document.createElement('script')
        script.async = true
        script.src = scriptURL;
        (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(script)
        script.onload = ShopifyBuyInit
      }

      function ShopifyBuyInit () {
        // eslint-disable-next-line
        var client = ShopifyBuy.buildClient({
          domain: 'wizzle-world.myshopify.com',
          storefrontAccessToken: 'ce114cabea3793a53cb012542dd506ec'
        })
        // eslint-disable-next-line
        ShopifyBuy.UI.onReady(client).then(function (ui) {
          ui.createComponent('collection', {
            id: '272063791264',
            node: document.getElementById('collection-component-1623345465798'),
            moneyFormat: '%24%7B%7Bamount%7D%7D',
            options: {
              'product': {
                'styles': {
                  'product': {
                    '@media (min-width: 601px)': {
                      'max-width': 'calc(25% - 20px)',
                      'margin-left': '20px',
                      'margin-bottom': '50px',
                      'width': 'calc(25% - 20px)'
                    }
                  },
                  'title': {
                    'font-family': 'Open Sans, sans-serif',
                    'color': '#000000'
                  },
                  'button': {
                    'font-family': 'Quantico, sans-serif',
                    'font-size': '16px',
                    'padding-top': '16px',
                    'padding-bottom': '16px',
                    ':hover': {
                      'background-color': '#000000'
                    },
                    'background-color': '#000000',
                    ':focus': {
                      'background-color': '#000000'
                    },
                    'border-radius': '0px'
                  },
                  'quantityInput': {
                    'font-size': '16px',
                    'padding-top': '16px',
                    'padding-bottom': '16px'
                  },
                  'price': {
                    'font-family': 'Open Sans, sans-serif',
                    'color': '#000000'
                  },
                  'compareAt': {
                    'font-family': 'Open Sans, sans-serif',
                    'color': '#000000'
                  },
                  'unitPrice': {
                    'font-family': 'Open Sans, sans-serif',
                    'color': '#000000'
                  }
                },
                'text': {
                  'button': 'Add to cart'
                },
                'googleFonts': [
                  'Open Sans',
                  'Quantico'
                ]
              },
              'productSet': {
                'styles': {
                  'products': {
                    '@media (min-width: 601px)': {
                      'margin-left': '-20px'
                    }
                  }
                }
              },
              'modalProduct': {
                'contents': {
                  'img': false,
                  'imgWithCarousel': true
                },
                'styles': {
                  'product': {
                    '@media (min-width: 601px)': {
                      'max-width': '100%',
                      'margin-left': '0px',
                      'margin-bottom': '0px'
                    }
                  },
                  'button': {
                    'font-family': 'Quantico, sans-serif',
                    'font-size': '16px',
                    'padding-top': '16px',
                    'padding-bottom': '16px',
                    ':hover': {
                      'background-color': '#000000'
                    },
                    'background-color': '#000000',
                    ':focus': {
                      'background-color': '#000000'
                    },
                    'border-radius': '0px'
                  },
                  'quantityInput': {
                    'font-size': '16px',
                    'padding-top': '16px',
                    'padding-bottom': '16px'
                  },
                  'title': {
                    'font-family': 'Open Sans, sans-serif',
                    'font-weight': 'bold',
                    'font-size': '26px',
                    'color': '#000000'
                  },
                  'price': {
                    'font-family': 'Open Sans, sans-serif',
                    'font-weight': 'normal',
                    'font-size': '18px',
                    'color': '#000000'
                  },
                  'compareAt': {
                    'font-family': 'Open Sans, sans-serif',
                    'font-weight': 'normal',
                    'font-size': '15.299999999999999px',
                    'color': '#000000'
                  },
                  'unitPrice': {
                    'font-family': 'Open Sans, sans-serif',
                    'font-weight': 'normal',
                    'font-size': '15.299999999999999px',
                    'color': '#000000'
                  },
                  'description': {
                    'font-family': 'Open Sans, sans-serif',
                    'color': '#000000'
                  }
                },
                'googleFonts': [
                  'Open Sans',
                  'Quantico'
                ],
                'text': {
                  'button': 'Add to cart'
                }
              },
              'option': {},
              'cart': {
                'styles': {
                  'button': {
                    'font-family': 'Quantico, sans-serif',
                    'font-size': '16px',
                    'padding-top': '16px',
                    'padding-bottom': '16px',
                    ':hover': {
                      'background-color': '#000000'
                    },
                    'background-color': '#000000',
                    ':focus': {
                      'background-color': '#000000'
                    },
                    'border-radius': '0px'
                  },
                  'title': {
                    'color': '#000000'
                  },
                  'header': {
                    'color': '#000000'
                  },
                  'lineItems': {
                    'color': '#000000'
                  },
                  'subtotalText': {
                    'color': '#000000'
                  },
                  'subtotal': {
                    'color': '#000000'
                  },
                  'notice': {
                    'color': '#000000'
                  },
                  'currency': {
                    'color': '#000000'
                  },
                  'close': {
                    'color': '#000000',
                    ':hover': {
                      'color': '#000000'
                    }
                  },
                  'empty': {
                    'color': '#000000'
                  },
                  'noteDescription': {
                    'color': '#000000'
                  },
                  'discountText': {
                    'color': '#000000'
                  },
                  'discountIcon': {
                    'fill': '#000000'
                  },
                  'discountAmount': {
                    'color': '#000000'
                  }
                },
                'text': {
                  'total': 'Subtotal',
                  'button': 'Checkout'
                },
                'popup': false,
                'googleFonts': [
                  'Quantico'
                ]
              },
              'toggle': {
                'styles': {
                  'toggle': {
                    'font-family': 'Quantico, sans-serif',
                    'background-color': '#000000',
                    ':hover': {
                      'background-color': '#000000'
                    },
                    ':focus': {
                      'background-color': '#000000'
                    }
                  },
                  'count': {
                    'font-size': '16px'
                  }
                },
                'googleFonts': [
                  'Quantico'
                ]
              },
              'lineItem': {
                'styles': {
                  'variantTitle': {
                    'color': '#000000'
                  },
                  'title': {
                    'color': '#000000'
                  },
                  'price': {
                    'color': '#000000'
                  },
                  'fullPrice': {
                    'color': '#000000'
                  },
                  'discount': {
                    'color': '#000000'
                  },
                  'discountIcon': {
                    'fill': '#000000'
                  },
                  'quantity': {
                    'color': '#000000'
                  },
                  'quantityIncrement': {
                    'color': '#000000',
                    'border-color': '#000000'
                  },
                  'quantityDecrement': {
                    'color': '#000000',
                    'border-color': '#000000'
                  },
                  'quantityInput': {
                    'color': '#000000',
                    'border-color': '#000000'
                  }
                }
              }
            }
          })
        })
      }
    })()
  }
}
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/mixins';

iframe {
  height: 1000px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/vendorPortal/resources.vue